export const enum EVENT_CODE {
  left = 'ArrowLeft', // 37
  up = 'ArrowUp', // 38
  right = 'ArrowRight', // 39
  down = 'ArrowDown', // 40
  esc = 'Escape',
}
